
import Vue from "vue";
export default Vue.extend({
	data() {
		return {
			records: 2
		};
	},
	methods: {
		cancel(){
			this.$emit("cancel");
		},
		confirm(){
			this.$emit("confirm",this.records);
		}
	},
	i18nEx: {
		componentPrefix: "components.bank.coda-split-rules"
	}
});
